import {
    StyleSheet
} from "react-native";
import {
    NCoreUIKitTheme,
    webStyle
} from "ncore-ui-kit";

const stylesheet = ({
    colors,
    spaces
}: ReturnType<typeof NCoreUIKitTheme.useContext>) => StyleSheet.create({
    terminalContainer: {
        backgroundColor: colors.content.container.primary,
        padding: spaces.spacingMd,
        borderRadius: 8,
        flex: 1
    },
    toolbarButton: {
        paddingHorizontal: spaces.spacingSm,
        paddingVertical: spaces.spacingXs,
        backgroundColor: "#000000",
        borderColor: "#00ff00",
        borderRadius: 4,
        borderWidth: 1,
        ...webStyle({
            userSelect: "none",
            cursor: "pointer"
        })
    },
    errorText: {
        color: colors.content.text.danger,
        marginTop: spaces.spacingXs,
        fontFamily: "monospace",
        fontSize: 14
    },
    toolbarContainer: {
        marginBottom: spaces.spacingMd,
        gap: spaces.spacingSm,
        flexDirection: "row",
        flexWrap: "wrap"
    },
    outputContainer: {
        marginBottom: spaces.spacingMd,
        flex: 1
    },
    promptText: {
        marginRight: spaces.spacingSm,
        fontFamily: "monospace",
        color: "#00ff00",
        fontSize: 14
    },
    outputText: {
        marginTop: spaces.spacingXs,
        fontFamily: "monospace",
        color: "#00ff00",
        fontSize: 14
    },
    textInput: {
        fontFamily: "monospace",
        color: "#00ff00",
        fontSize: 14,
        padding: 0,
        margin: 0,
        flex: 1
    },
    toolbarButtonText: {
        fontFamily: "monospace",
        color: "#00ff00",
        fontSize: 12
    },
    inputContainer: {
        flexDirection: "row",
        alignItems: "center"
    }
});

export default stylesheet;
